export const IS_ADMIN_LOGIN = "adminLogin";
export const IS_CUSTOMER_LOGIN = "customerLogin";
